import GoToPlatformModal from './GoToPlatformModal';

export default GoToPlatformModal;



// WEBPACK FOOTER //
// ./src/components/shared/GoToPlatformModal/index.js